import cn from "clsx";
import { PlanningClassification } from "../../types";

interface PlanningApplicationClassificationProps {
  classification: PlanningClassification;
}

export function PlanningApplicationClassification({ classification }: PlanningApplicationClassificationProps) {
  return (
    <li
      className={cn("flex items-center justify-center h-[18px] w-[18px] rounded-full text-white text-sm", {
        "bg-[#ff3665]": classification === PlanningClassification.RESIDENTIAL,
        "bg-[#8e36ff]": classification === PlanningClassification.COMMERCIAL,
        "bg-[#30b3df]": classification === PlanningClassification.OTHER,
        "bg-linear-to-b from-[#ff3665] to-[#8e36ff]": classification === PlanningClassification.MIXED_USE,
      })}
    >
      {classification === PlanningClassification.RESIDENTIAL && "R"}
      {classification === PlanningClassification.COMMERCIAL && "C"}
      {classification === PlanningClassification.OTHER && "O"}
      {classification === PlanningClassification.MIXED_USE && "M"}
    </li>
  );
}
